import { render } from "./ImgSelector.vue?vue&type=template&id=3cd2177f&scoped=true"
import script from "./ImgSelector.vue?vue&type=script&lang=js"
export * from "./ImgSelector.vue?vue&type=script&lang=js"

import "./ImgSelector.vue?vue&type=style&index=0&id=3cd2177f&scoped=true&lang=css"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd2177f"]])

export default __exports__